import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import GetLoanExpense from "Communication/ApiClasses/GetLoanExpenseRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleGetLoanExpense(action) {
  yield put(doLoadingStart(STRINGS.EXPENSE.API_KEYS.LOAN_GET_EXPENSE));
  const getLoanExpense = new GetLoanExpense(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.financialId
  );
  try {
    const result = yield call(getLoanExpense.getData);
    yield put({
      type: actionTypes.LOAN_GET_EXPENSE_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_GET_EXPENSE_ERROR,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(STRINGS.EXPENSE.API_KEYS.LOAN_GET_EXPENSE));
  }
}

// watcher
function* getLoanExpenseWatcherSaga() {
  yield takeLatest(actionTypes.LOAN_GET_EXPENSE, handleGetLoanExpense);
}

export default getLoanExpenseWatcherSaga;
